// For pages that can be accessed without a login.  For example the login screen 

export default function guest({ to, next, userData }) {
    if (userData) {
        return next('/dashboard');
    }
    return next();
}
